module.exports = __webpack_public_path__ + "img/bg-type03-pc.3a356e83.png";